import { DownSquareOutlined } from '@ant-design/icons';
import { Radio } from 'antd';
import { orderMethodsState } from 'components/pages/dashboard/ParcelOrder/ParcelOrder';
import OrderMethodItem from 'components/pages/dashboard/ParcelOrder/components/orderMethods/OrderMethodItem';
import { packageCreate } from 'global/Models/omOrderModel';
import { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

interface IOrderMethodDeliveryType {
  deliveryTypeId?: number;
  handleChange: (_values: Partial<orderMethodsState>) => void;
  packages: packageCreate[];
}

const OrderMethodDeliveryType: FC<IOrderMethodDeliveryType> = ({ deliveryTypeId, handleChange, packages }) => {
  //states
  const { deliveryTypes } = useSelector((state: RootState) => state.parcelOrder);

  const hasEcoPack = packages?.some((item) => item?.package?.some((pkg) => pkg?.packagingGroupId === 70));

  const filteredDeliveryTypes = deliveryTypes?.filter((dt) => !(hasEcoPack && dt.id === 20));

  useEffect(() => {
    if (!filteredDeliveryTypes?.length || !handleChange) return;
    const validIds = filteredDeliveryTypes.map((i) => i.id);
    if (!deliveryTypeId || !validIds.includes(deliveryTypeId)) {
      handleChange({ deliveryTypeId: validIds[0] });
    }
  }, [filteredDeliveryTypes, deliveryTypeId, hasEcoPack]);

  return (
    <OrderMethodItem icon={<DownSquareOutlined className='text-2xl' />} title='نحوه توزیع'>
      <div className='flex flex-col gap-4 sm:flex-row'>
        {filteredDeliveryTypes?.map((item) => (
          <div
            key={item.id}
            className={`px-4 py-2 flex items-center w-full md:w-fit border rounded-md select-none  gap-2 ${deliveryTypeId === item.id && 'border-t-primary-color'}`}
            // onClick={() => handleChange({ deliveryTypeId: item.id })}
          >
            <Radio checked={deliveryTypeId === item.id} disabled />
            {item.title}
          </div>
        ))}
      </div>
    </OrderMethodItem>
  );
};

export default OrderMethodDeliveryType;
